import React from 'react';
import s from '../notification.module.css';
export function Content(_a) {
    var message = _a.message, description = _a.description;
    return (React.createElement("div", { className: s.content },
        message && React.createElement("h6", { className: s.heading }, message),
        description && React.createElement("p", { className: s.description }, description)));
}
//# sourceMappingURL=Content.js.map